import { gql } from '@apollo/client';

export const GET_PORTAL_PAGES = gql`
  query GetPortalPages {
    myAccount {
      id
      name
      currentSeason {
        id
        name
        vendorPortalPages {
          id
          title
          content
          attachments {
            id
            fileType
            fileName
            size
          }
          isPublic
          status
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const CREATE_VENDOR_PORTAL_PAGE = gql`
  mutation CreateVendorPortalPage(
    $seasonId: String!
    $data: CreateVendorPortalPageInput!
  ) {
    createVendorPortalPage(seasonId: $seasonId, data: $data) {
      id
    }
  }
`;

export const UPDATE_VENDOR_PORTAL_PAGE = gql`
  mutation UpdateVendorPortalPage(
    $id: String!
    $updates: UpdateVendorPortalPageInput!
  ) {
    updateVendorPortalPage(id: $id, updates: $updates) {
      id
    }
  }
`;

export const DELETE_VENDOR_PORTAL_PAGE = gql`
  mutation DeleteVendorPortalPage($id: String!) {
    deleteVendorPortalPage(id: $id) {
      result
    }
  }
`;
